export const ARRAY_TO_ID_FILTER_MAP = (filterList) => {
  return filterList.map((object) => {
    return object.id || object.key;
  });
};

export const TEXT_FILTER_MAP = (text) => {
  return text;
};
export const TEXT_LIKE_FILTER_MAP = (text) => {
  return `~${text}`;
};

export const NUMBER_LIKE_FILTER_MAP = (text) => {
  return `~${text}`;
};
